import { useMutation } from '@tanstack/react-query';
import type {
  UpdateBankAddressRequestDto,
  UpdateBankAddressResponseDto,
} from '../../model';
import { updateBankAddress } from '../requests';

interface Options {
  onSuccess?: (data: UpdateBankAddressResponseDto) => void;
  onError?: (error: Error) => void;
}

type UpdateBankAddressVariables = {
  templateId: string;
  data: UpdateBankAddressRequestDto;
};

export function useUpdateBankAddress({ onSuccess, onError }: Options) {
  const mutation = useMutation<
    UpdateBankAddressResponseDto,
    Error,
    UpdateBankAddressVariables
  >({
    mutationFn: ({ templateId, data }) => updateBankAddress(templateId, data),
    onSuccess,
    onError,
  });

  return {
    mutate: mutation.mutate,
    mutateAsync: mutation.mutateAsync,
    data: mutation.data,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
